"use strict";
class IScriptEventProxy {
}
exports.IScriptEventProxy = IScriptEventProxy;
